import React from "react";
import type { IBranchMergeModalsProps } from "./branch-merge-types";
import ChangesFoundModal from "./changes-found-modal";
import MergeToBranchModal from "./merge-to-branch-modal";

export const BranchMergeModals: React.FC<IBranchMergeModalsProps> = ({
  showMergeToBranchModal,
  showChangesFoundModal,
  branchOptions,
  currentBranchId,
  onCloseMergeToBranchModal,
  onStartMerge,
  onMerge,
  onCloseChangesFoundModal,
  onIgnoreChangesAndMerge,
  onCommitAndMerge,
  changesFoundCommitMessage,
  changesFoundInProgress,
  onChangesFoundCommitMessageChange
}) => (
  <>
    {showMergeToBranchModal && (
      <MergeToBranchModal
        showModal={showMergeToBranchModal}
        onClose={onCloseMergeToBranchModal}
        onStartMerge={onStartMerge}
        onMerge={onMerge}
        branches={branchOptions}
        currentBranchId={currentBranchId}
      />
    )}
    {showChangesFoundModal && (
      <ChangesFoundModal
        showModal={showChangesFoundModal}
        commitMessage={changesFoundCommitMessage}
        inProgress={changesFoundInProgress}
        onClose={onCloseChangesFoundModal}
        onCommitMessageChange={onChangesFoundCommitMessageChange}
        onIgnoreChangesAndMerge={onIgnoreChangesAndMerge}
        onCommitAndMerge={onCommitAndMerge}
      />
    )}
  </>
);
